<template>
	<section class="form-group FormCheckbox" :data-entry="id || name" :data-multiselect="multiselect">
		<label v-if="label" class="title" :for="id || name" :class="{ required }">{{ label }}</label>
		<div class="input-area">
			<label
				v-for="option in options"
				:key="option.value"
				class="checkbox"
				:class="{ checked: multiselect ? value.includes(option.value) : value === option.value }"
				:for="`${formId}_${id || name}_${option.value}`"
			>
				<span>{{ option.label }}</span>
				<input
					class="input"
					:id="`${formId}_${id || name}_${option.value}`"
					v-bind="$attrs"
					:value="value"
					@change="onCheck(option.value)"
					type="checkbox"
					:checked="multiselect ? value.includes(option.value) : value === option.value"
				/>
			</label>
		</div>
	</section>
</template>

<script>
	import mixin from './mixin';
	export default {
		mixins: [mixin],
		props: {
			options: Array,
			multiselect: {
				type: Boolean,
				default: true
			}
		},
		methods: {
			onCheck(id) {
				if (this.multiselect) {
					let value = this.value;
					if (typeof value === 'string') {
						value = [this.value];
					}
					if (value.includes(id)) {
						this.$emit(
							'change',
							value.filter(e => e !== id)
						);
					} else {
						this.$emit('change', [...value, id]);
					}
				} else {
					this.$emit('change', id);
				}
			}
		}
	};
</script>

<style scoped lang="scss">
	.FormCheckbox {
		.input-area {
			margin: -0.5rem;
			label {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				width: initial !important;
				cursor: pointer;

				margin: 0.5rem;
				margin-right: 3rem;

				&::before {
					content: '✓';
					display: flex;
					align-items: center;
					justify-content: center;
					width: 1.5em;
					height: 1.5em;
					font-size: 2rem;
					border-radius: 2em;
					border: solid 1px var(--color);
					margin-right: 1rem;
					color: transparent;
					flex: 0 0 1.5em;
				}

				&.checked {
					&::before {
						color: var(--color);
					}
				}
			}

			input {
				display: none;
			}
		}
	}
</style>
